import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../auth';

@Component({
  selector: 'app-login',
  imports: [FormsModule],
  templateUrl: './login.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Login {
  readonly #authService = inject(AuthService);
  readonly #router = inject(Router);

  protected readonly email = signal('');
  protected readonly password = signal('');
  protected readonly stayLoggedIn = signal(true);
  protected readonly error = signal('');
  protected readonly isLoggingIn = signal(false);

  protected async login() {
    if (this.isLoggingIn()) return;

    this.isLoggingIn.set(true);
    this.error.set('');
    try {
      await this.#authService.login(this.email(), this.password(), this.stayLoggedIn());
      await this.#router.navigate(['/main']);
    } catch (error) {
      this.error.set(error instanceof Error ? error.message : 'Login failed. Please try again.');
    } finally {
      this.isLoggingIn.set(false);
    }
  }
}
